import WboTransportProvider from '@/components/common/ed-board/ed-board-tools/wbo-client/interfaces/wbo-transport-provider.interface';
import WboConnectionStatusObserver from '@/components/common/ed-board/ed-board-tools/wbo-client/interfaces/wbo-connection-status-observer.interface';
import {
    WboAnnotationDocumentMetadata,
    WboDelta,
    WboRequestMessage,
    WboServerResponse
} from '@/components/common/ed-board/ed-board-tools/wbo-client/model/wbo-annotation.model';
import WboSocketIoTransportProvider from './wbo-socketio-transport-provider';
import WboHttpTransportProvider from './wbo-http-transport-provider';

/**
 * A transport provider that combines both WebSocket (via Socket.IO) and HTTP transports.
 * It uses WebSocket for real-time updates and HTTP for request/response patterns.
 */
export default class WboMixedTransportProvider implements WboTransportProvider {
    private socketIoTransport: WboSocketIoTransportProvider;
    private httpTransport: WboHttpTransportProvider;

    constructor(
        socketIoTransport: WboSocketIoTransportProvider,
        boardName: string
    ) {
        this.socketIoTransport = socketIoTransport;
        this.httpTransport = new WboHttpTransportProvider(boardName);
    }

    addConnectionStatusObserver(observer: WboConnectionStatusObserver): void {
        this.socketIoTransport.addConnectionStatusObserver(observer);
    }

    close(): void {
        this.socketIoTransport.close();
        this.httpTransport.close();
    }

    initialize(): void {
        this.socketIoTransport.initialize();
        this.httpTransport.initialize();
    }

    isConnected(): boolean {
        return this.socketIoTransport.isConnected();
    }

    onMessage(handler: (delta: WboDelta) => void): void {
        this.socketIoTransport.onMessage(handler);
    }

    sendDelta(message: WboDelta): void {
        this.socketIoTransport.sendDelta(message);
    }

    sendDeltaWithAck(message: WboDelta): Promise<WboServerResponse | undefined> {
        return this.socketIoTransport.sendDeltaWithAck(message);
    }

    async sendRequest(request: WboRequestMessage): Promise<any> {
        return this.httpTransport.sendRequest(request);
        // return this.socketIoTransport.sendRequest(request);
    }

    subscribe(boardName: string, boardMetadata: WboAnnotationDocumentMetadata): void {
        this.socketIoTransport.subscribe(boardName, boardMetadata);
    }
}
